import { Button, Select, Upload } from "antd";
import sharedClasses from "../AdminAgentsDocuments.module.css";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";

// TODO: пока мокну данные так
const selectOptions = [
  { key: "1", label: "doc 1.docx", value: "doc 1.docx" },
  { key: "2", label: "doc 2.docx", value: "doc 2.docx" },
  { key: "3", label: "doc 3.docx", value: "doc 3.docx" },
];

export const AdminAgentsContracts = () => {
  return (
    <div>
      <div className={sharedClasses.sectionTitle}>Договоры</div>
      <Upload showUploadList={false} className={sharedClasses.upload}>
        <Button size="large" className={sharedClasses.uploadBtn}>
          <PlusOutlined />
          Загрузить договор
        </Button>
      </Upload>

      <Select
        value={null}
        placeholder={"Список загружаемых документов"}
        options={selectOptions}
        optionRender={(value) => {
          return (
            <div className={sharedClasses.optionItem}>
              <span>{value.label}</span>

              <UploadOutlined className={sharedClasses.optionItemIcon} />
            </div>
          );
        }}
        dropdownStyle={{ position: "relative" }}
        size="large"
        className={sharedClasses.docListSelect}
      />
    </div>
  );
};
